import { faEyeSlash } from "@fortawesome/pro-regular-svg-icons";
import { faEyeSlash as faEyeSlashSolid } from "@fortawesome/pro-solid-svg-icons";
import React from "react";
import { useFormContext } from "react-hook-form";

import { Icon } from "src/base-components/Icon";
import { Tooltip } from "src/design-system/Tooltip";
import {
  CommonSchemaEditRowProps,
  SchemaUI,
} from "src/schema/schemaMappingUtils";

const PiiDescriptionActive =
  "This field contains personally identifiable information and is made unavailable during backtesting and exports.";
const PiiDescriptionInactive =
  "Enable this toggle for fields that contain personally identifiable information, so that they can be made unavailable during backtesting and exports.";

export const SchemaSensitiveToggle: React.FC<CommonSchemaEditRowProps> = ({
  rowName,
  disabled,
}) => {
  const { getValues, setValue } = useFormContext<SchemaUI>();
  const value = getValues(`${rowName}.sensitive`);
  return (
    <Tooltip
      body={value ? PiiDescriptionActive : PiiDescriptionInactive}
      placement="right"
      title={
        value
          ? "This field is not stored in Decision History"
          : "Do not store in Decision History"
      }
      asChild
    >
      <div className="flex items-center">
        <Icon
          color={
            value ? "text-indigo-600" : "text-gray-500 hover:text-gray-700"
          }
          dataLoc={`schema-field-sensitive-${value}`}
          disabled={disabled}
          icon={value ? faEyeSlashSolid : faEyeSlash}
          size="xs"
          onClick={() => setValue(`${rowName}.sensitive`, !value)}
        />
      </div>
    </Tooltip>
  );
};
